import React from 'react'
import { OneColorIconProps } from '../utils'

export const SponsorLogoIcon: React.FC<OneColorIconProps> = ({ size = 48, className }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="-65.52"
          y1="4.35"
          x2="-39.96"
          y2="4.35"
          gradientTransform="translate(-39.74 17.35) rotate(-180)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#cf1c24" />
          <stop offset=".12" stopColor="#d91f22" />
          <stop offset=".42" stopColor="#ee2620" />
          <stop offset=".72" stopColor="#fa2a1f" />
          <stop offset="1" stopColor="#ff2c1f" />
        </linearGradient>
        <clipPath id="clippath">
          <circle fill="none" cx="13" cy="13" r="12.12" />
        </clipPath>
        <linearGradient
          id="linear-gradient-2"
          x1="-63.41"
          y1="4.35"
          x2="-42.07"
          y2="4.35"
          xlinkHref="#linear-gradient"
        />
        <filter id="drop-shadow-2" x="10.26" y="4.73" width="5.47" height="1.42" filterUnits="userSpaceOnUse">
          <feOffset dx="0" dy=".1" />
          <feGaussianBlur result="blur" stdDeviation="0" />
          <feFlood floodColor="#000" floodOpacity=".2" />
          <feComposite in2="blur" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <clipPath id="clippath-1">
          <rect fill="none" x="10.26" y="4.73" width="5.47" height="1.32" />
        </clipPath>
        <filter id="drop-shadow-3" x="5.46" y="8.44" width="15.09" height="7.87" filterUnits="userSpaceOnUse">
          <feOffset dx="0" dy=".1" />
          <feGaussianBlur result="blur-2" stdDeviation="0" />
          <feFlood floodColor="#000" floodOpacity=".2" />
          <feComposite in2="blur-2" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
        <filter id="drop-shadow-4" x="9.73" y="18.59" width="6.54" height="2.78" filterUnits="userSpaceOnUse">
          <feOffset dx="0" dy=".1" />
          <feGaussianBlur result="blur-3" stdDeviation="0" />
          <feFlood floodColor="#000" floodOpacity=".2" />
          <feComposite in2="blur-3" operator="in" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <circle fill="url(#linear-gradient)" cx="13" cy="13" r="12.78" />
      <g>
        <g clipPath="url(#clippath)">
          <rect fill="#d81f22" x=".88" y=".88" width=".62" height="24.25" />
          <rect fill="#da2022" x="1.5" y=".88" width=".62" height="24.25" />
          <rect fill="#dc2022" x="2.12" y=".88" width=".62" height="24.25" />
          <rect fill="#de2122" x="2.74" y=".88" width=".62" height="24.25" />
          <rect fill="#e02221" x="3.36" y=".88" width=".62" height="24.25" />
          <rect fill="#e12221" x="3.98" y=".88" width=".62" height="24.25" />
          <rect fill="#e32321" x="4.61" y=".88" width=".62" height="24.25" />
          <rect fill="#e52321" x="5.23" y=".88" width=".62" height="24.25" />
          <rect fill="#e62421" x="5.85" y=".88" width=".62" height="24.25" />
          <rect fill="#e82421" x="6.47" y=".88" width=".62" height="24.25" />
          <rect fill="#e92521" x="7.09" y=".88" width=".62" height="24.25" />
          <rect fill="#eb2521" x="7.72" y=".88" width=".62" height="24.25" />
          <rect fill="#ec2620" x="8.34" y=".88" width=".62" height="24.25" />
          <rect fill="#ee2620" x="8.96" y=".88" width=".62" height="24.25" />
          <rect fill="#ef2720" x="9.58" y=".88" width=".62" height="24.25" />
          <rect fill="#f02720" x="10.2" y=".88" width=".62" height="24.25" />
          <rect fill="#f22820" x="10.82" y=".88" width=".62" height="24.25" />
          <rect fill="#f32820" x="11.45" y=".88" width=".62" height="24.25" />
          <rect fill="#f42820" x="12.07" y=".88" width=".62" height="24.25" />
          <rect fill="#f52920" x="12.69" y=".88" width=".62" height="24.25" />
          <rect fill="#f62920" x="13.31" y=".88" width=".62" height="24.25" />
          <rect fill="#f72920" x="13.93" y=".88" width=".62" height="24.25" />
          <rect fill="#f82a20" x="14.55" y=".88" width=".62" height="24.25" />
          <rect fill="#f92a1f" x="15.18" y=".88" width=".62" height="24.25" />
          <rect fill="#f92a1f" x="15.8" y=".88" width=".62" height="24.25" />
          <rect fill="#fa2a1f" x="16.42" y=".88" width=".62" height="24.25" />
          <rect fill="#fb2b1f" x="17.04" y=".88" width=".62" height="24.25" />
          <rect fill="#fb2b1f" x="17.66" y=".88" width=".62" height="24.25" />
          <rect fill="#fc2b1f" x="18.28" y=".88" width=".62" height="24.25" />
          <rect fill="#fd2b1f" x="18.91" y=".88" width=".62" height="24.25" />
          <rect fill="#fd2b1f" x="19.53" y=".88" width=".62" height="24.25" />
          <rect fill="#fe2c1f" x="20.15" y=".88" width=".62" height="24.25" />
          <rect fill="#fe2c1f" x="20.77" y=".88" width=".62" height="24.25" />
          <rect fill="#fe2c1f" x="21.39" y=".88" width=".62" height="24.25" />
          <rect fill="#ff2c1f" x="22.02" y=".88" width=".62" height="24.25" />
          <rect fill="#ff2c1f" x="22.64" y=".88" width=".62" height="24.25" />
          <rect fill="#ff2c1f" x="23.26" y=".88" width=".62" height="24.25" />
          <rect fill="#ff2c1f" x="23.88" y=".88" width=".62" height="24.25" />
          <rect fill="#ff2c1f" x="24.5" y=".88" width=".62" height="24.25" />
        </g>
        <path
          fill="#fff"
          d="M13,25.31C6.21,25.31.69,19.79.69,13S6.21.69,13,.69s12.31,5.52,12.31,12.31-5.52,12.31-12.31,12.31ZM13,1.06C6.42,1.06,1.06,6.42,1.06,13s5.35,11.94,11.94,11.94,11.94-5.36,11.94-11.94S19.58,1.06,13,1.06Z"
        />
      </g>
      <circle fill="url(#linear-gradient-2)" cx="13" cy="13" r="10.67" />
      <g>
        <g filter="url(#drop-shadow-2)">
          <g clipPath="url(#clippath-1)">
            <g>
              <path
                fill="#fff"
                d="M15.71,5.84l-.4-.09v-.82s0-.02,0-.02c0,0-.01-.01-.02-.01l-.18-.02s-.01,0-.02,0c0,0,0,.01,0,.02,0,0,0,0,0,0v1s0,.01,0,.02c0,0,.01,0,.02.01l.61.13s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0v-.16s0-.01,0-.02c0,0-.01-.01-.02-.01Z"
              />
              <path
                fill="#fff"
                d="M14.67,4.83l-.61-.05s0,0-.01,0c0,0,0,0,0,0,0,0,0,0,0,0s0,0,0,.01v.98s0,.01,0,.02c0,0,.01,0,.02,0l.61.05s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0v-.16s0-.01,0-.02-.01,0-.02-.01l-.41-.03v-.2l.34.03s.01,0,.02,0c0,0,0,0,0-.02,0,0,0,0,0,0v-.16s0-.01,0-.02c0,0-.01,0-.02-.01l-.34-.03v-.18l.41.04s0,0,0,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0v-.16s0-.01,0-.02c0,0-.01,0-.02-.01Z"
              />
              <path
                fill="#fff"
                d="M13.62,5.18h-.37s0,0-.01,0c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01v.16s0,0,0,.01c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.01,0,.03,0,.14,0,.17,0v.15s-.09.02-.13.02c-.18,0-.29-.14-.29-.3s.11-.3.29-.3c.07,0,.14.02.19.08,0,0,.01,0,.02,0s.01,0,.02,0l.12-.12s0,0,0,0c0,0,0,0,0-.01s0,0,0-.01c0,0,0,0,0,0-.1-.09-.24-.15-.36-.15-.3,0-.53.24-.53.53s.24.52.53.53c.13,0,.26-.03.37-.09,0,0,0,0,0,0,0,0,0,0,0-.01v-.48s0-.01,0-.02c0,0-.01,0-.02,0Z"
              />
              <path
                fill="#fff"
                d="M10.56,5.99s0,0,0,0c0,0-.24.07-.25.07,0,0,0,0-.01,0,0,0,0,0-.01,0,0,0,0,0,0,0s0,0,0-.01c0,0,0-.01,0-.01l.52-1.11s0-.01.02-.01c0,0,.01,0,.02,0,.02,0,.04.02.04.02l.43.93s0,.01,0,.02c0,.02-.02.03-.03.03l-.18.02s-.02,0-.03,0l-.27-.14s-.02-.04,0-.04l.17-.03-.12-.27h0s0,0,0,0l-.26.57s0,0,0,0Z"
              />
              <path
                fill="#fff"
                d="M12.4,4.78h-.18s-.02,0-.02.02c0,0,0,.01,0,.02v.53l-.57-.51s-.09-.02-.09.01v1s0,.01,0,.02c0,0,.01,0,.02,0h.18s.01-.02.02-.02c0,0,0-.01,0-.02v-.55h0l.59.56s.07.01.07-.02v-1s0,0,0-.01c0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0-.01,0h0Z"
              />
            </g>
          </g>
        </g>
        <g filter="url(#drop-shadow-3)">
          <path
            fill="#fff"
            d="M6.57,10.68l-.48-.71h-.14v.69h-.49v-1.99h.71c.5,0,.79.22.79.63,0,.28-.15.47-.4.57l.52.73-.52.08ZM6.12,9.04h-.18v.58h.17c.23,0,.37-.1.37-.3,0-.18-.12-.29-.36-.29Z"
          />
          <path
            fill="#fff"
            d="M7.99,10.69c-.47,0-.8-.24-.8-.78,0-.49.31-.79.74-.79.48,0,.69.34.69.78,0,.05,0,.09,0,.12h-.97c.03.24.18.33.4.33.18,0,.35-.06.52-.16l.05.33c-.17.1-.38.17-.63.17ZM7.64,9.77h.54c-.02-.23-.11-.34-.27-.34-.15,0-.26.11-.28.34Z"
          />
          <path
            fill="#fff"
            d="M9.93,10.66l-.03-.2c-.11.11-.26.23-.46.23-.33,0-.58-.23-.58-.74,0-.57.32-.81.68-.81.14,0,.25.02.34.05v-.68l.46-.07v2.22h-.4ZM9.87,9.55c-.08-.03-.14-.05-.25-.05-.18,0-.31.12-.31.42,0,.26.11.37.26.37.11,0,.21-.06.3-.16v-.58Z"
          />
          <path
            fill="#fff"
            d="M12.35,10.7c-.62,0-1-.4-1-1.03s.4-1.03,1.03-1.03c.22,0,.4.05.56.13l-.07.44c-.13-.09-.28-.16-.47-.16-.34,0-.55.24-.55.62s.22.62.57.62c.18,0,.33-.06.49-.15l.06.41c-.17.09-.36.15-.61.15Z"
          />
          <path
            fill="#fff"
            d="M14.16,10.66l-.03-.19c-.13.13-.29.22-.51.22-.25,0-.44-.15-.44-.42,0-.35.29-.52.92-.57v-.03c0-.14-.08-.19-.25-.19-.18,0-.35.04-.52.11l-.05-.35c.18-.07.38-.12.64-.12.43,0,.64.14.64.52v1.01h-.4ZM14.11,9.93c-.37.05-.47.16-.47.29,0,.1.07.15.17.15s.2-.04.3-.12v-.32Z"
          />
          <path fill="#fff" d="M15.4,9.82v.84h-.46v-1.51h.4l.05.3c.1-.18.24-.32.48-.33l.07.47c-.24.02-.42.11-.54.23Z" />
          <path
            fill="#fff"
            d="M16.98,10.68c-.14,0-.25-.02-.34-.05v.54l-.46.07v-2.08h.4l.04.2c.11-.11.25-.23.46-.23.33,0,.58.23.58.74,0,.57-.32.81-.67.81ZM16.93,9.53c-.11,0-.21.06-.29.16v.58c.08.03.14.05.25.05.18,0,.31-.12.31-.42,0-.26-.11-.37-.26-.37Z"
          />
          <path
            fill="#fff"
            d="M18.69,10.69c-.47,0-.8-.24-.8-.78,0-.49.31-.79.74-.79.48,0,.69.34.69.78,0,.05,0,.09,0,.12h-.97c.03.24.18.33.4.33.18,0,.35-.06.52-.16l.05.33c-.17.1-.38.17-.63.17ZM18.33,9.77h.54c-.02-.23-.11-.34-.27-.34-.15,0-.26.11-.28.34Z"
          />
          <path
            fill="#fff"
            d="M20.27,10.68c-.33,0-.56-.11-.56-.5v-.66h-.21v-.37h.21v-.45l.45-.07v.52h.31l.06.37h-.36v.59c0,.12.06.18.2.18.04,0,.08,0,.12-.02l.06.38c-.08.02-.15.03-.27.03Z"
          />
          <path
            fill="#fff"
            d="M7.48,12.76h-.15v.66h-.49v-1.99h.66c.5,0,.81.22.81.65s-.34.68-.83.68ZM7.47,11.8h-.15v.59h.13c.24,0,.38-.1.38-.3,0-.19-.12-.29-.36-.29Z"
          />
          <path
            fill="#fff"
            d="M9.02,12.58v.84h-.46v-1.51h.4l.05.3c.1-.18.24-.32.48-.33l.08.47c-.24.02-.42.11-.54.23Z"
          />
          <path
            fill="#fff"
            d="M10.46,13.45c-.47,0-.8-.24-.8-.78,0-.49.31-.79.74-.79.48,0,.69.34.69.78,0,.05,0,.09,0,.12h-.97c.03.24.18.33.4.33.18,0,.35-.06.52-.16l.05.33c-.17.1-.38.17-.63.17ZM10.11,12.53h.54c-.02-.23-.11-.34-.27-.34-.15,0-.25.11-.27.34Z"
          />
          <path
            fill="#fff"
            d="M13.23,13.42v-.95c0-.11-.05-.19-.17-.19-.1,0-.19.05-.29.14v1h-.46v-.95c0-.11-.05-.19-.17-.19-.1,0-.19.05-.28.14v1h-.46v-1.51h.4l.04.21c.15-.14.3-.24.5-.24.22,0,.34.1.4.24.14-.13.3-.24.5-.24.3,0,.45.17.45.47v1.07h-.46Z"
          />
          <path
            fill="#fff"
            d="M14.31,11.71c-.15,0-.27-.1-.27-.25s.12-.25.27-.25.26.1.26.25-.11.25-.26.25ZM14.08,13.42v-1.51h.46v1.51h-.46Z"
          />
          <path
            fill="#fff"
            d="M15.65,13.45c-.47,0-.8-.24-.8-.78,0-.49.31-.79.74-.79.48,0,.69.34.69.78,0,.05,0,.09,0,.12h-.97c.03.24.18.33.4.33.18,0,.35-.06.52-.16l.05.33c-.17.1-.38.17-.63.17ZM15.3,12.53h.54c-.02-.23-.11-.34-.27-.34-.15,0-.26.11-.28.34Z"
          />
          <path
            fill="#fff"
            d="M17.05,12.58v.84h-.46v-1.51h.4l.05.3c.1-.18.24-.32.48-.33l.07.47c-.24.02-.42.11-.54.23Z"
          />
          <path
            fill="#fff"
            d="M18.5,13.45c-.47,0-.8-.24-.8-.78,0-.49.31-.79.74-.79.48,0,.69.34.69.78,0,.05,0,.09,0,.12h-.97c.03.24.18.33.4.33.18,0,.35-.06.52-.16l.05.33c-.17.1-.38.17-.63.17ZM18.15,12.53h.54c-.02-.23-.11-.34-.27-.34-.15,0-.25.11-.27.34Z"
          />
          <path
            fill="#fff"
            d="M8.55,15.52h-.15v.66h-.49v-1.99h.66c.5,0,.81.22.81.65s-.34.68-.83.68ZM8.54,14.56h-.15v.59h.13c.24,0,.38-.1.38-.3,0-.19-.12-.29-.36-.29Z"
          />
          <path
            fill="#fff"
            d="M10.47,16.18l-.03-.19c-.13.13-.29.22-.51.22-.25,0-.44-.15-.44-.42,0-.35.29-.52.92-.57v-.03c0-.13-.08-.19-.25-.19-.18,0-.35.04-.52.11l-.05-.35c.18-.07.38-.11.64-.11.43,0,.64.14.64.52v1.01h-.4ZM10.42,15.44c-.37.05-.47.16-.47.29,0,.1.07.15.17.15s.2-.04.3-.12v-.32Z"
          />
          <path
            fill="#fff"
            d="M11.7,15.34v.84h-.46v-1.51h.4l.05.3c.1-.18.24-.32.48-.33l.08.47c-.24.02-.42.11-.54.23Z"
          />
          <path
            fill="#fff"
            d="M13.15,16.2c-.33,0-.56-.11-.56-.5v-.66h-.21v-.37h.21v-.45l.45-.07v.52h.31l.06.37h-.36v.59c0,.12.06.18.2.18.04,0,.08,0,.12-.02l.06.38c-.08.02-.15.03-.27.03Z"
          />
          <path
            fill="#fff"
            d="M14.63,16.18v-.95c0-.11-.05-.19-.18-.19-.1,0-.2.05-.29.14v.99h-.46v-1.51h.4l.04.21c.15-.13.3-.24.5-.24.29,0,.45.17.45.47v1.07h-.46Z"
          />
          <path
            fill="#fff"
            d="M16.19,16.21c-.47,0-.8-.24-.8-.78,0-.49.31-.79.74-.79.48,0,.69.34.69.78,0,.05,0,.09,0,.12h-.97c.03.24.18.34.4.34.18,0,.35-.06.52-.16l.05.33c-.17.1-.38.17-.63.17ZM15.84,15.28h.54c-.02-.23-.11-.34-.27-.34-.15,0-.26.11-.28.34Z"
          />
          <path
            fill="#fff"
            d="M17.59,15.34v.84h-.46v-1.51h.4l.05.3c.1-.18.24-.32.48-.33l.08.47c-.24.02-.42.11-.54.23Z"
          />
        </g>
        <g filter="url(#drop-shadow-4)">
          <path
            fill="#fff"
            d="M11.62,20.65c-.71,0-1.28-.58-1.28-1.28h.19c0,.6.49,1.09,1.09,1.09s1.09-.49,1.09-1.09h.19c0,.71-.58,1.28-1.28,1.28Z"
          />
          <g>
            <circle fill="#fff" cx="10.24" cy="18.88" r=".29" />
            <path
              fill="#fff"
              d="M10.53,20.99v-1.77c-.08.07-.18.12-.29.12s-.21-.05-.29-.12v1.77h-.22v.28h1.02v-.28h-.22Z"
            />
          </g>
          <g>
            <circle fill="#fff" cx="13" cy="18.88" r=".29" />
            <path
              fill="#fff"
              d="M13.29,20.99v-1.77c-.08.07-.18.12-.29.12s-.21-.05-.29-.12v1.77h-.22v.28h1.02v-.28h-.22Z"
            />
          </g>
          <path
            fill="#fff"
            d="M14.38,20.65c-.71,0-1.28-.58-1.28-1.28h.19c0,.6.49,1.09,1.09,1.09s1.09-.49,1.09-1.09h.19c0,.71-.58,1.28-1.28,1.28Z"
          />
          <g>
            <circle fill="#fff" cx="15.76" cy="18.88" r=".29" />
            <path
              fill="#fff"
              d="M16.05,20.99v-1.77c-.08.07-.18.12-.29.12s-.21-.05-.29-.12v1.77h-.22v.28h1.02v-.28h-.22Z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
